import { Link, Typography } from '@mui/material'
import { Icons } from 'utoniq-ui'

import { ItemType } from '@/clients/utoniq-core/schema'
import { Head } from '@/components/layouts'
import { ConsoleBaseLayout } from '@/components/layouts/ConsoleBaseLayout'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Cell, CellFrame, Template } from '@/core/architecture'

import {
  FileUploadInfo,
  ItemCreateForm,
  ItemCreateFormProps,
} from './ItemCreateForm'

export * from './fragments'

export type State = {
  artistId: string
  walletAddress?: string
  resourceType: ItemType
  progress: number
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onDrop: FileUploadInfo['onDrop']
  onSubmit: ItemCreateFormProps['onSubmit']
}

export const ConsoleItemCreateTemplate: Template<State, Action> = ({
  state,
  onDrop,
  onSubmit,
}) => {
  const { t } = useTranslation('consoleItemCreate')
  const { routerNames, routerPages } = useRouter()
  return (
    <ArtistThemeProvider artistId={state.artistId}>
      <Head title={routerNames.ConsoleItemCreate} />

      <ConsoleBaseLayout
        margin
        header={{
          back: true,
          defaultBackPage: routerPages.ConsoleItems,
          title: t('title'),
        }}
      >
        <HeadingTextCell resourceType={state.resourceType} />
        <ItemCreateForm
          fileUploadInfo={{
            progress: state.progress,
            onDrop,
          }}
          resourceType={state.resourceType}
          onSubmit={onSubmit}
        />
      </ConsoleBaseLayout>
    </ArtistThemeProvider>
  )
}

type HeadingTextCellProps = {
  resourceType: ItemType
}
export const HeadingTextCell: Cell<HeadingTextCellProps> = ({
  resourceType,
}) => {
  const { t } = useTranslation('consoleItemCreate')
  return (
    <CellFrame sx={{ pt: 2 }}>
      <Typography variant="h3" sx={{ py: 3 }}>
        {t(`${resourceType}NewIssueItem`)}
      </Typography>
      <Link
        component="a"
        target="_blank"
        href={'https://help.utoniq.com/ja/articles/8878771'}
        variant="caption"
        sx={{ alignItems: 'center', display: 'flex' }}
      >
        {t(`${resourceType}NewIssueItemNote`)}
        <Icons.Help fontSize="xSmall" color="inherit" sx={{ ml: 1 }} />
      </Link>
    </CellFrame>
  )
}
